import { listBusinesses } from "../services/businessService.js";

// Guards every "New Filing" entry point (sidebar button, Dashboard's own
// button) the same way the Form 720 reference's DashboardLayout.openNewFiling
// does: a brand-new user with zero saved businesses gets sent to the
// Business Details form first, since FormTypeStep's Business dropdown would
// otherwise have nothing to select. The Business form is told to send the
// user on into the wizard's Form step (rather than back to the Businesses
// list) once their first business is saved - see BusinessForm.jsx's use of
// location.state.returnTo.
//
// Goes straight to /wizard/1 (FormTypeStep) rather than a separate
// filing-type-picker page first - that page used to make the filer choose
// the filing type twice (once on its own cards, again on FormTypeStep, which
// already has its own Business/Tax Preparer/filing-type picker). SEED resets
// any in-progress wizard state first, so this always starts a clean filing.
export async function goToNewFiling({ dispatch, navigate, showToast }) {
  dispatch({ type: "SEED", which: "new" });
  try {
    const businesses = await listBusinesses();
    if (businesses.length === 0) {
      showToast("Add a business first to start filing.");
      navigate("/dashboard/businesses/form", { state: { returnTo: "/wizard/1" } });
      return;
    }
  } catch {
    // On error fall through - FormTypeStep handles an empty/failed business
    // list the same way it always does.
  }
  navigate("/wizard/1");
}
